import Vue         from 'vue';
import Router      from 'vue-router';
import AppHeader   from './layout/en/AppHeader';
import AppFooter   from './layout/en/AppFooter';
import SmallFooter from './layout/en/SmallFooter';
import Landing     from './views/en/Landing.vue';
import Online      from './views/en/Online.vue';
import ForAgents   from './views/en/ForAgents.vue';
import Api         from './views/en/Api.vue';
import Pricing     from './views/en/Pricing.vue';
import Contacts    from './views/en/Contacts.vue';
import Terms       from './views/en/Terms.vue';
import Privacy     from './views/en/Privacy.vue';
import Error       from './views/en/Error.vue';

Vue.use ( Router );

export default new Router ( {
	linkExactActiveClass: 'active',
	routes              : [
		{
			path      : '/',
			name      : 'landing',
			components: {
				header : AppHeader,
				default: Landing,
				footer : AppFooter
			}
		},
		{
			path      : '/online',
			name      : 'online',
			components: {
				header : AppHeader,
				default: Online,
				footer : AppFooter
			}
		},
		{
			path      : '/for-agents',
			name      : 'for_agents',
			components: {
				header : AppHeader,
				default: ForAgents,
				footer : AppFooter
			}
		},
		{
			path      : '/api',
			name      : 'api',
			components: {
				header : AppHeader,
				default: Api,
				footer : AppFooter
			}
		},
		{
			path      : '/pricing',
			name      : 'pricing',
			components: {
				header : AppHeader,
				default: Pricing,
				footer : AppFooter
			}
		},
		{
			path      : '/contacts',
			name      : 'contacts',
			components: {
				header : AppHeader,
				default: Contacts,
				footer : AppFooter
			}
		},
		{
			path      : '/tos',
			name      : 'terms',
			components: {
				header : AppHeader,
				default: Terms,
				footer : SmallFooter
			}
		},
		{
			path      : '/privacy',
			name      : 'privacy',
			components: {
				header : AppHeader,
				default: Privacy,
				footer : SmallFooter
			}
		},
		{
			path: '*',
			//redirect: { name: 'home' },
			components: {
				header : AppHeader,
				default: Error,
				footer : SmallFooter
			}
		}
	],
	scrollBehavior      : to => {
		if ( to.hash ) {
			return { selector: to.hash };
		} else {
			return { x: 0, y: 0 };
		}
	}
} );
